import axios from "axios";

//axios.defaults.withCredentials = true;
export default class HttpRequest {
  constructor(options) {
    this.defaults = {
      baseUrl: "",
      //timeout: 1000,
      //headers: {'X-Custom-Header': 'foobar'}
    };
    this.defaults = Object.assign(this.defaults, options);
  }

  setConfig() { }

  interceptors(install) {
    //Add a request interceptor
    install.interceptors.request.use(
      (config) => {
        let token = localStorage.getItem(
          "token_" + (new URLSearchParams(location.search).get("sourceType") ? new URLSearchParams(location.search).get("sourceType") : sessionStorage.getItem("pathSource"))
        );
        // 判断是否存在token，如果存在的话，则每个http header都加上token
        if (token) {
          config.headers.authorization = `Bearer ${token}`;
        }
        // 添加安全的响应头
        config.headers['Strict-Transport-Security'] = 'max-age=31536000; includeSubDomains'; // HSTS
        config.headers['X-Content-Type-Options'] = 'nosniff'; // 防止 MIME 类型混淆攻击
        config.headers['X-Frame-Options'] = 'DENY'; // 防止点击劫持
        config.headers['Content-Security-Policy'] = "default-src 'self'"; // 内容安全策略
        config.headers['Referrer-Policy'] = 'no-referrer'; // 引用策略
        return config;
      },
      (err) => {
        return Promise.reject(err);
      }
    );
    // Add a response interceptor
    install.interceptors.response.use(
      (res) => {
        /* 注意查看结构 */
        const { data } = res;
        return data;
      },
      (err) => {
        const error = { mesCode: err.response.status, objError: err };
        if (err.response.status != 400 && err.response.status != 403 && err.response.status != 404 && err.response.status != 500) {
          error.mesCode = 500;
        }
        return Promise.reject(error);
      }
    );
  }

  request(options) {
    options = Object.assign(this.defaults, options);
    options.httpsAgent = {
      rejectUnauthorized: true,
      secureProtocol: 'TLSv1_2_method'
    };
    const instance = axios.create(options);
    this.interceptors(instance);
    return instance;
  }
}

